import { polyfill } from 'keyboardevent-key-polyfill';

// Enables us to use KeyboardEvent.key in all environments
polyfill();
